import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card, Row, Paragraph, Separator, BillboardButton, colors } from '@fs/zion-ui'
import { NoticeQuestion, ContentCheck, ContentAdd } from '@fs/zion-icon'
import RecordTooltipButton from './RecordTooltipButton'

const IsEverythingAccountedForCard = ({ overlay, handleNewEntity, handleClick, isStepThree }) => {
  const [t] = useTranslation()

  return (
    <Card edges="elevation" backgroundColor={colors.yellow02}>
      <Row>
        <NoticeQuestion size="md" background={colors.yellow03} noShrinkX />
        <Paragraph size="sm">
          <strong>
            {isStepThree
              ? t('family-review.step3.is-everything-accounted-for-q', 'Is everything in this record accounted for?')
              : t('family-review.step2.is-everyone-here-q', 'Is everyone in this record accounted for?')}
          </strong>
        </Paragraph>
        <RecordTooltipButton overlay={overlay} stepText={isStepThree ? 'Three' : 'Two'} />
      </Row>
      <Separator size="sm" />
      <BillboardButton
        linkName={
          isStepThree ? 'Family Review Step Three Yes Button' : 'Family Review Step Two Everyone Is Here Button'
        }
        Icon={ContentCheck}
        onClick={handleClick}
        emphasis="lightHigh"
        color="yellow"
        data-testid={isStepThree ? 'yes-button' : 'everyone-is-here-button'}
      >
        {isStepThree
          ? t('family-review.step3.yes', 'Yes')
          : t('family-review.step2.everyone-is-here', 'Everyone is here')}
      </BillboardButton>
      <Separator size="sm" />
      <BillboardButton
        Icon={ContentAdd}
        onClick={handleNewEntity}
        data-testid={isStepThree ? 'add-event' : 'add-person'}
        linkName={isStepThree ? 'Step Three Add Event' : 'Step Two Add Person'}
        color="yellow"
        emphasis="low"
      >
        {isStepThree
          ? t('family-review.step3.add-new-event-button', 'Add new event')
          : t('family-review.step2.add-new-person-button', 'Add new person')}
      </BillboardButton>
    </Card>
  )
}

export default IsEverythingAccountedForCard
